import React, { useState, useEffect, useRef } from "react";
import {
  Calendar,
  Form,
  Input,
  Button,
  Select,
  Typography,
  Row,
  Col,
  Card,
  Space,
  Drawer,
  Table,
  Avatar,
  Popover,
  DatePicker,
} from "antd";
import dayjs from "dayjs";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useNavigate, useParams } from "react-router-dom";
import logoicon from "../../logoicon.png";
import {
  CalendarOutlined,
  DoubleRightOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import AddProduct from "features/ProductsandServices/Components/AddProduct";
import AddEmployee from "features/Admin/Employees/Components/AddEmployee";
import AddLead from "features/Leads/LeadCommonComponents/AddLead";
import imgmedia from "../../media-85.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { resetWorkOrderDetails } from "../Clients/ClientsSlice";
import {
  faCheckCircle,
  faChevronCircleDown,
  faChevronUp,
  faFolderOpen,
  faLayerGroup,
  faPauseCircle,
  faTimesCircle,
  faUserAlt,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import {
  getClientAPI,
  getSourceOfLeadsAPI,
  getStatusAPI,
} from "CommonComponents/Lookup/LookupAPI";
import AddPartnerClient from "features/Clients/PartnerClients/AddPartnerClient";
import AddClient from "features/Clients/Clients/AddClient";
import { useDispatch, useSelector } from "react-redux";
import { GetLeadsApi, getLeadStatusCountAPI } from "features/Leads/LeadsAPI";
import { setLeadRecords } from "features/Leads/LeadsSlice";
import {
  GetClientsListApi,
  getInvoicesByCompanyId,
  getPartnerClientsCountAPI,
  GetPartnerClientsListApi,
  getTotalClientsCountAPI,
  getWorkOrdersByCompanyId,
} from "features/Clients/ClientsApi";
import CreateQuote from "./CreateQuote";
import { getQuotesListByCompanyIdAPI } from "features/Quotes/QuotesApi";
function Dashboard() {
  const { Column } = Table;
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const { Title, Text } = Typography;
  const intl = useIntl();
  const navigate = useNavigate();
  const companysId = localStorage.getItem("CompanyId");

  const [collapsed, setCollapsed] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dateRange, setDateRange] = useState([dayjs(), dayjs()]);
  const [openWorkOrderModel, setOpenWorkOrderModel] = useState(false);
  const [openInvoiceModel, setOpenInvoiceModel] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("All");
  const [openQuoteModel, setOpenQuoteModel] = useState(false);
  const LeadData = useSelector((state) => state.leads.leadRecords);
  const clientsList = useSelector((state) => state.clients.clientsList);
  const estimatesList = useSelector((state) => state.quotes.quotesList);
  const workOrdersList = useSelector(
    (state) => state.clients.workOrdersListByCompanyId
  );
  const partnerClientsList = useSelector(
    (state) => state.clients.partneclientsList
  );
  const sourceOfLeads = useSelector((state) => state.lookup.sourceOfLead);
  const clients = useSelector((state) => state.lookup.clientList);
  const statusCount = useSelector((state) => state.leads?.statusCount);
  const clientCount = useSelector((state) => state.clients.clientsCount);
  const partnerClientCount = useSelector(
    (state) => state.clients.partnerClientsCount
  );
  const invoicesList = useSelector(
    (state) => state.clients.invoicesListByCompanyId
  );
  const openLeads =
    statusCount?.find((item) => item.statusId === 5)?.leadCount || 0;
  const closedLeads =
    statusCount?.find((item) => item.statusId === 6)?.leadCount || 0;
  const rejectedLeads =
    statusCount?.find((item) => item.statusId === 7)?.leadCount || 0;
  const totalLeads = openLeads + closedLeads + rejectedLeads;
  const toggleStats = () => {
    setCollapsed(!collapsed);
  };
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const [open1, setOpen1] = useState(false);
  const showDrawer1 = () => {
    setOpen1(true);
  };
  const onClose1 = () => {
    setOpen1(false);
  };
  const [open2, setOpen2] = useState(false);
  const showDrawer2 = () => {
    setOpen2(true);
  };
  const onClose2 = () => {
    setOpen2(false);
  };
  const [form] = Form.useForm();
  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };
  useEffect(() => {
    dispatch(getLeadStatusCountAPI());
    dispatch(getSourceOfLeadsAPI());
    dispatch(getTotalClientsCountAPI());
    dispatch(getPartnerClientsCountAPI());
  }, [companyId]);
  const pagination = {
    pageNo: 1,
    pageSize: 5,
    searchQuery: "",
    companyFilter: null,
    isSearch: false,
    startDate: null,
    endDate: null,
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  useEffect(() => {
    const isSearch = searchTerm !== "";
    if (!isSearch) {
      dispatch(
        setLeadRecords({ data: [], totalPages: 0, pageNo: 1, isSearch: true })
      );
    }
    dispatch(GetLeadsApi({ ...pagination, isSearch }));
    dispatch(GetClientsListApi({ ...pagination, isSearch }));
    dispatch(getQuotesListByCompanyIdAPI({ ...pagination, isSearch }));
    dispatch(GetPartnerClientsListApi({ ...pagination, isSearch }));
    dispatch(getWorkOrdersByCompanyId({ ...pagination, isSearch }));
    dispatch(getInvoicesByCompanyId({ ...pagination, isSearch }));
  }, [
    dispatch,
    currentPage,
    searchTerm,
    selectedCompany,
    dateRange,
    companyId,
  ]);
  useEffect(() => {
    dispatch(resetWorkOrderDetails());
  }, []);
  const stats = [
    {
      title: <FormattedMessage id="Dashboard.TotalClients" />,
      value: clientCount,
      icon: <FontAwesomeIcon icon={faUserAlt} style={{ fontSize: 20 }} />,
      color: "#F472B6",
    },
    {
      title: <FormattedMessage id="Dashboard.TotalPartners" />,
      value: partnerClientCount,
      icon: <FontAwesomeIcon icon={faUserTie} style={{ fontSize: 20 }} />,
      color: "#dfb50b",
    },
    {
      title: <FormattedMessage id="Dashboard.TotalLeads" />,
      value: totalLeads,
      icon: <FontAwesomeIcon icon={faLayerGroup} style={{ fontSize: 20 }} />,
      color: "#6c757d ",
    },
    {
      title: <FormattedMessage id="Dashboard.OpenLeads" />,
      value: openLeads,
      icon: <FontAwesomeIcon icon={faFolderOpen} style={{ fontSize: 20 }} />,
      color: "#1ECBE2 ",
    },

    {
      title: <FormattedMessage id="Dashboard.ClosedLeads" />,
      value: closedLeads,
      icon: <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 20 }} />,
      color: "#5CB85C",
    },
    {
      title: <FormattedMessage id="Dashboard.RejectedLeads" />,
      value: rejectedLeads,
      icon: <FontAwesomeIcon icon={faTimesCircle} style={{ fontSize: 20 }} />,
      color: "#FC0027",
    },
  ];
  const handleRowClick = (record) => {
    navigate(`/${companyId}/${record.id}/lead_view`);
  };
  return (
    <>
      <div
        className="medispamain"
        style={{ position: "relative", paddingBottom: 20 }}
      >
        <div className="main-area">
          <div className="title-part detailsposition">
            <Row justify="space-between">
              <Col>
                <h4>{<FormattedMessage id="Common.Dashboard" />}</h4>
              </Col>
              <Col>
                <Avatar
                  shape="square"
                  size={32}
                  onClick={toggleStats}
                  style={{
                    backgroundColor: "#fff",
                    color: "#262A2A",
                    border: "1px solid #E8E8E8",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      transform: collapsed ? "rotate(90deg)" : "rotate(-90deg)",
                      position: "relative",
                      left: collapsed ? "1px" : "-1px",
                    }}
                  >
                    <DoubleRightOutlined style={{ fontSize: "14px" }} />
                  </span>
                </Avatar>
              </Col>
            </Row>
          </div>
          <Row
            gutter={[16, 8]}
            align="top"
            className="leads-stats-main"
            style={{ display: collapsed ? "none" : "flex" }}
          >
            <Col xs={24} md={10} className="leads-stats">
              <Link to={`/${companyId}/createlead`}>
                <Card className="create-lead-box">
                  <Space className="text-center">
                    <div>
                      <Space>
                        <h4 style={{ color: "#fff" }}>
                          <PlusCircleOutlined />
                          &nbsp;{
                            <FormattedMessage id="Dashboard.CreateLead" />
                          }{" "}
                          →
                        </h4>
                      </Space>

                      <Text
                        className="mt-20"
                        style={{ color: "white", display: "block" }}
                      >
                        {
                          <FormattedMessage id="Dashboard.LookingForReliableSolutions" />
                        }
                      </Text>
                    </div>
                  </Space>
                </Card>
              </Link>
            </Col>
            <Col xs={24} md={14}>
              <Row gutter={[16, 8]}>
                {stats.map((stat, idx) => (
                  <Col xs={24} sm={12} md={12} lg={8} xl={8} key={idx}>
                    <Card>
                      <Row align="middle" wrap={false}>
                        {/* Left Side: Title + Value */}
                        <Col flex="1 1 auto" style={{ minWidth: 0 }}>
                          <Text
                            type="secondary"
                            ellipsis={{ tooltip: stat.title }}
                          >
                            {stat.title}
                          </Text>
                          <Title level={3} style={{ margin: 0 }}>
                            {stat.value?.toLocaleString()}
                          </Title>
                        </Col>

                        {/* Right Side: Avatar */}
                        <Col flex="0 0 30px">
                          <Avatar
                            shape="square"
                            size={30}
                            style={{
                              backgroundColor: stat.color,
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {stat.icon}
                          </Avatar>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="dashboard mt-10">
            <Col xs={24} md={24} lg={12}>
              <Card
                title={<FormattedMessage id="Common.Leads" />}
                extra={
                  <>
                    <Link to={`/${companyId}/createlead`}>
                      <Button variant="outlined">
                        <PlusCircleOutlined />
                        {<FormattedMessage id="Lead.Submit" />}
                      </Button>
                    </Link>
                  </>
                }
              >
                <Row align="middle" gutter={8}>
                  <Col span={24}>
                    <Table
                      dataSource={LeadData}
                      bordered
                      scroll={{ x: 600 }}
                      pagination={false}
                      onRow={(record) => ({
                        onClick: () => handleRowClick(record),
                      })}
                    >
                      <Column
                        title={<FormattedMessage id="Lead.LeadNumber" />}
                        dataIndex="leadNo"
                        key="leadno"
                        render={(_, record) => (
                          <Link to={`/${companyId}/${record.id}/lead_view`}>
                            {record.leadNumber}
                          </Link>
                        )}
                      />
                      <Column
                        title={<FormattedMessage id="Lead.DateTime" />}
                        dataIndex="date"
                        key="date"
                        render={(_, record) =>
                          dayjs(record.dateTime).format("DD-MMM-YYYY")
                        }
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Leads.ClientName" />
                        }
                        width={150}
                        ellipsis={{ showTitle: false }}
                        dataIndex="clientname"
                        key="clientname"
                        render={(_, record) => (
                          <Typography.Text ellipsis>
                            {record.clientName}
                          </Typography.Text>
                        )}
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Leads.LeadSource" />
                        }
                        key="leadsource"
                        dataIndex="leadsource"
                        render={(_, record) =>
                          sourceOfLeads.find(
                            (s) => s.id === record.sourceOfLeadId
                          )?.sourceName
                        }
                      />
                    </Table>
                  </Col>
                  <Col span={24} className="text-center mt-10">
                    <Link to={`/${companyId}/leads`}>
                      {<FormattedMessage id="Dashboard.Leads.ViewAllLeads" />}
                    </Link>
                  </Col>
                </Row>
                {/* <AddLead
                  open={open}
                  onClose={() => {
                    setOpen(false);
                  }}
                  pagination={pagination}
                /> */}
              </Card>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <Card
                title={<FormattedMessage id="Dashboard.Quotes" />}
                extra={
                  <Button variant="outlined" onClick={setOpenQuoteModel}>
                    <PlusCircleOutlined />
                    {<FormattedMessage id="AddEstimate.AddEstimate" />}
                  </Button>
                }
              >
                <Row align="middle" gutter={8}>
                  <Col span={24}>
                    <Table
                      dataSource={estimatesList}
                      bordered
                      pagination={false}
                      scroll={{ x: 600 }}
                    >
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Quotes.QuoteNumber" />
                        }
                        dataIndex="estimateNo"
                        key="estimateNo"
                        render={(_, record) => (
                          <Link
                            to={`/${companyId}/${record?.clientId}/client_details/${record?.id}/viewquote`}
                          >
                            {record?.estimateNo}
                          </Link>
                        )}
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Quotes.ClientName" />
                        }
                        dataIndex="clientOrPartnerName"
                        key="clientOrPartnerName"
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Quotes.QuoteDate" />
                        }
                        dataIndex="dateTime"
                        key="date"
                        width={130}
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Quotes.QuoteAmount" />
                        }
                        dataIndex="grandTotal"
                        key="amount"
                        width={130}
                      />
                    </Table>
                  </Col>
                  <Col span={24} className="text-center mt-10">
                    <Link to={`/${companyId}/quotes`}>
                      {<FormattedMessage id="Dashboard.Quotes.ViewAllQuotes" />}
                    </Link>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <Card
                title={<FormattedMessage id="ClientDetails.WorkOrders" />}
                extra={
                  <Button
                    variant="outlined"
                    onClick={() => setOpenWorkOrderModel(true)}
                  >
                    <PlusCircleOutlined />

                    <FormattedMessage id="ClientDetails.CreateWo" />
                  </Button>
                }
              >
                <Row align="middle" gutter={8}>
                  <Col span={24}>
                    <Table
                      dataSource={workOrdersList}
                      bordered
                      pagination={false}
                      scroll={{ x: 600 }}
                    >
                      <Column
                        title={
                          <FormattedMessage id="WorkOrderDetails.WorkOrderNo" />
                        }
                        dataIndex="woNumber"
                        key="woNumber"
                        render={(_, record) => {
                          let linkPath = "";

                          if (record?.partnerId && record?.clientId) {
                            linkPath = `/${companyId}/${record?.partnerId}/partner_client_details/${record?.clientId}/client_details/${record?.projectId}/projects/wo_details/${record?.id}`;
                          } else if (record?.partnerId) {
                            linkPath = `/${companyId}/${record?.partnerId}/partner_client_details/wo_details/${record?.id}`;
                          } else if (record.clientId) {
                            linkPath = `/${companyId}/${record?.clientId}/client_details/wo_details/${record?.id}`;
                          }

                          return <Link to={linkPath}>{record?.woNumber}</Link>;
                        }}
                      />

                      <Column
                        title={<FormattedMessage id="Clients.ClientName" />}
                        key="displayName"
                        render={(text, record) =>
                          record?.clientName || record?.partnerName
                        }
                      />

                      <Column
                        title={
                          <FormattedMessage id="CreateWorkOrder.ReferenceQuoteNo" />
                        }
                        dataIndex="estimateReference"
                        key="estimateReference"
                        render={(text) =>
                          text || <FormattedMessage id="WorkOrder.NoQuote" />
                        }
                      />
                      <Column
                        title={<FormattedMessage id="ClientDetails.Amount" />}
                        dataIndex="grandTotal"
                        key="grandTotal"
                        width={130}
                      />
                    </Table>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <Card
                title={<FormattedMessage id="Invoice.Heading" />}
                extra={
                  <Button
                    variant="outlined"
                    onClick={() => setOpenInvoiceModel(true)}
                  >
                    <PlusCircleOutlined />

                    <FormattedMessage id="Invoice.GenerateInvoice" />
                  </Button>
                }
              >
                <Row align="middle" gutter={8}>
                  <Col span={24}>
                    <Table
                      dataSource={invoicesList}
                      bordered
                      pagination={false}
                      scroll={{ x: 600 }}
                    >
                      <Column
                        title={<FormattedMessage id="Invoice.InvoiceNo" />}
                        dataIndex="invoiceNumber"
                        key="invoiceNumber"
                        render={(_, record) => {
                          let linkPath = "";

                          if (record?.partnerClientId && record?.clientId) {
                            linkPath = `/${companyId}/${record?.partnerClientId}/partner_client_details/${record?.clientId}/client_details/${record?.projectId}/projects/wo_details/${record?.workOrderId}/viewinvoice/${record?.id}`;
                          } else if (record?.partnerClientId) {
                            linkPath = `/${companyId}/${record?.partnerClientId}/partner_client_details/wo_details/${record?.workOrderId}/viewinvoice/${record?.id}`;
                          } else if (record.clientId) {
                            linkPath = `/${companyId}/${record?.clientId}/client_details/wo_details/${record?.workOrderId}/viewinvoice/${record?.id}`;
                          }

                          return (
                            <Link to={linkPath}>{record?.invoiceNumber}</Link>
                          );
                        }}
                      />

                      <Column
                        title={<FormattedMessage id="Clients.ClientName" />}
                        key="displayName"
                        render={(text, record) =>
                          record?.clientName || record?.partnerName
                        }
                      />

                      <Column
                        title={
                          <FormattedMessage id="WorkOrderDetails.WorkOrderNo" />
                        }
                        dataIndex="workOrderReference"
                        key="workOrderReference"
                        render={(text) =>
                          text || <FormattedMessage id="WorkOrder.NoQuote" />
                        }
                      />
                      <Column
                        title={<FormattedMessage id="ClientDetails.Amount" />}
                        dataIndex="invoicingAmount"
                        key="invoicingAmount"
                        width={130}
                      />
                    </Table>
                  </Col>
                </Row>
              </Card>
            </Col>
            {/* <Col span={12}>
              <Card
                title={<FormattedMessage id="Dashboard.Clients" />}
                extra={
                  <Button type="primary" block onClick={showDrawer2}>
                    <PlusCircleOutlined />
                    {<FormattedMessage id="Dashboard.Clients.AddClient" />}
                  </Button>
                }
              >
                <Row align="middle" gutter={8}>
                  <Col span={24}>
                    <Table dataSource={clientsList} bordered pagination={false}>
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ClientName" />
                        }
                        dataIndex="name"
                        width={120} // Needed so the cell knows its boundary
                        ellipsis={{ showTitle: false }} // showTitle:false = no default tooltip
                        key="clientname"
                        render={(_, record) => (
                          <Typography.Text ellipsis style={{ width: "100%" }}>
                            <Link
                              to={`/${companyId}/${record.id}/client_details/`}
                              style={{ textTransform: "capitalize" }}
                            >
                              {record.isResidential === true
                                ? record.name
                                : record.companyName}
                            </Link>
                          </Typography.Text>
                        )}
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ClientPhone" />
                        }
                        dataIndex="phone"
                        key="phone"
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ClientEmail" />
                        }
                        dataIndex="email"
                        key="email"
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ContactPerson" />
                        }
                        dataIndex="billingCpname"
                        key="billingCpname"
                      />
                    </Table>
                  </Col>
                  <Col span={24} className="text-center mt-10">
                    <Link to={`/${companyId}/clients`}>
                      {
                        <FormattedMessage id="Dashboard.Clients.ViewAllClients" />
                      }
                    </Link>
                  </Col>
                </Row>
                <Drawer
                  title={<FormattedMessage id="Dashboard.Clients.AddClient" />}
                  width={600}
                  onClose={onClose2}
                  open={open2}
                >
                  <AddClient
                    open={open2}
                    onClose={() => {
                      setOpen2(false);
                    }}
                    pagination={pagination}
                  />
                </Drawer>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                title={<FormattedMessage id="Dashboard.Partners" />}
                extra={
                  <Button type="primary" block onClick={showDrawer1}>
                    <PlusCircleOutlined />
                    {<FormattedMessage id="Dashboard.Partners.AddPartner" />}
                  </Button>
                }
              >
                <Row align="middle" gutter={8}>
                  <Col span={24}>
                    <Table
                      dataSource={partnerClientsList}
                      bordered
                      pagination={false}
                    >
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ClientName" />
                        }
                        dataIndex="companyName"
                        key="companyName"
                        width={180} // Needed so the cell knows its boundary
                        ellipsis={{ showTitle: false }} // showTitle:false = no default tooltip
                        render={(_, record) => (
                          <Typography.Text ellipsis style={{ width: "100%" }}>
                            <Link
                              to={`/${companyId}/${record.id}/partner_client_details/`}
                              style={{ textTransform: "capitalize" }}
                            >
                              {record.companyName}
                            </Link>
                          </Typography.Text>
                        )}
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ClientPhone" />
                        }
                        dataIndex="phone"
                        key="phone"
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ClientEmail" />
                        }
                        dataIndex="email"
                        key="email"
                      />
                      <Column
                        title={
                          <FormattedMessage id="Dashboard.Clients.ContactPerson" />
                        }
                        dataIndex="contactPerson"
                        key="contactPerson"
                      />
                    </Table>
                  </Col>
                  <Col span={24} className="text-center mt-10">
                    <Link to={`/${companyId}/partner`}>
                      {
                        <FormattedMessage id="Dashboard.Partners.ViewAllPartners" />
                      }
                    </Link>
                  </Col>
                </Row>
                <Drawer
                  title={
                    <FormattedMessage id="Dashboard.Partners.AddPartner" />
                  }
                  width={600}
                  onClose={onClose1}
                  open={open1}
                >
                  <AddPartnerClient
                    open={open1}
                    onClose={() => {
                      setOpen1(false);
                    }}
                    pagination={pagination}
                  />
                </Drawer>
              </Card>
            </Col> */}
            {/* {openQuoteModel && (
              <CreateQuote
                open={openQuoteModel}
                onCancel={() => setOpenQuoteModel(false)}
              />
            )} */}
            <CreateQuote
              open={openQuoteModel}
              onCancel={() => setOpenQuoteModel(false)}
              type="quote"
            />
            <CreateQuote
              open={openWorkOrderModel}
              onCancel={() => setOpenWorkOrderModel(false)}
              type="workorder"
            />
            <CreateQuote
              open={openInvoiceModel}
              onCancel={() => setOpenInvoiceModel(false)}
              type="invoice"
            />
          </Row>
        </div>
      </div>
    </>
  );
}
export default Dashboard;
